var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_37385",
    "data-name": "Group 37385",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31573",
    "data-name": "Path 31573",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31574",
    "data-name": "Path 31574",
    d: "M14.5,2a3.5,3.5,0,0,1,3.163,5H21a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1H20v8a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V13H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H6.337A3.5,3.5,0,0,1,12,3.051,3.48,3.48,0,0,1,14.5,2ZM18,13H6v7H18Zm2-4H4v2H20ZM9.5,4a1.5,1.5,0,0,0-.144,2.993L9.5,7H11V5.5A1.5,1.5,0,0,0,9.644,4.007Zm5,0-.144.007a1.5,1.5,0,0,0-1.35,1.349L13,5.5V7h1.5l.144-.007a1.5,1.5,0,0,0,0-2.986Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.e4637d68b1d3f410878edf4cf742b94e.svg";
export { ForwardRef as ReactComponent };